// Must execute before zone.js. Preserve the rejection/promise fields used by
// Zone's PromiseRejectionEvent bridge and Sentry's Angular error extractor.
// See ZoneGlobalConfigurations.DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION.
(
  globalThis as typeof globalThis & {
    __zone_symbol__DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION?: boolean;
  }
).__zone_symbol__DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION = false;
